/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreateFeedbackRequest = {
    type: CreateFeedbackRequest.type;
    negativeType?: CreateFeedbackRequest.negativeType | null;
    negativeOther?: string | null;
};

export namespace CreateFeedbackRequest {

    export enum type {
        POSITIVE = 'positive',
        NEGATIVE = 'negative',
    }

    export enum negativeType {
        NOT_CORRECT = 'not_correct',
        UNFOLLOW_INSTRUCTIONS = 'unfollow_instructions',
        OTHER = 'other',
    }


}

